// Firefox does not support native ClipboardItem therefore we use polyfill lib
import * as clipboard from 'clipboard-polyfill';

interface Link {
  link: string;
  title: string;
}

const constructLinks = (links: Link[]) =>
  links.map(({ link, title }) => `<a href="${link}">${title}</a>`).join('<br />');
const constructTitles = (links: Link[]) => links.map(({ link }) => link).join('\n');

const copyToClipboard = (links: Link[]): Promise<void> => {
  const data = [
    new clipboard.ClipboardItem({
      'text/html': new Blob([constructLinks(links)], { type: 'text/html' }),
      'text/plain': new Blob([constructTitles(links)], { type: 'text/plain' }),
    }),
  ];

  return clipboard.write(data);
};

export default copyToClipboard;
